export default __webpack_public_path__ + "static/media/nonVisibility.a1943f03.svg";